import {ApplicationStatus} from "../../models/opportunityApplication.model";
import Job from "../../models/job.model";

export const getQueryKey = (status: ApplicationStatus, job?: Job) => {
    return ['applicants', status, job?.id]
}
